import { useMsal } from "@azure/msal-react"
import { useEffect } from "react"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { loginRequest } from "../../config/authConfig"
import { changeRole, logout } from "../../services/login.service"
import { userActions } from "../../store/user"


export const DropDownButton = () => {
    const dispatch = useDispatch()
    const [selectedRole, setSelectedRole] = useState("User")
    const roles = useSelector(state => state.user.roles)
    const empType = useSelector(state => state.user.empType)
    const empName = useSelector(state => state.user.empName)
    const empId = useSelector(state => state.user.empId)
    const empEmail = useSelector(state => state.user.empEmail)
    const user = useSelector(state => state.user)
    const { instance } = useMsal()
    const panelChange = async (role) => {
        // const { status, data } = await changeRole(role)
        // if (status == 200) {
        //     sessionStorage.setItem("auth", data.token)
        //     window.location.href = '/'
        // }
        dispatch(userActions.login({...user, empType: role}));

    }

    const handleLogout = async () => {
        const logoutResponse = await logout();
        if(logoutResponse.status === 200){
            dispatch(userActions.logout());
            instance.logoutRedirect(loginRequest);
        }
    }

    return (
        <li className="nav-item dropdown dropdown-user">
            <a
                className="nav-link dropdown-toggle dropdown-user-link"
                id="dropdown-user"
                href="#"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <div className="user-nav d-sm-flex d-none">
                    <span className="user-name font-weight-bolder">{empName}</span>
                    <span className="user-status">@{empEmail && empEmail.split("@")[0]}</span>
                </div>
                <div className="starshot-ring mr-1">
                    <div className="avatar ">
                        <div className="text-icon font-lato font-18">{empName && empName[0]}</div>
                        <span className="avatar-status-online" />
                    </div>
                </div>
            </a>
            <div
                className="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdown-user"
            >

                {roles?.length && <a className="dropdown-item" onClick={() => {
                    if (empType == 52) {
                        panelChange(101)
                    } else {
                        panelChange(52)
                    }
                }}>
                    <i className="fas fa-user mr-1" /> {empType == 52 ? "Administrator" : "Switch to User"}
                </a>}

                <a className="dropdown-item" onClick={() => {
                    handleLogout()
                }}>
                    <i className="fas fa-sign-out-alt mr-1" /> Logout
                </a>
                <a className="dropdown-item" data-toggle="modal" data-target="#feedbackModal">
                    <i className="fas fa-comment-alt mr-1" /> Submit Feedback
                </a>
            </div>
        </li>
    )
}